/**
 * Legacy persisted filters may still be a single object-shaped DTO. Mirrors BE/ADR-0010: expand to empty.
 */
export const normalizeInclusionConditionArrayValue = <T>(value?: readonly T[] | T | null): T[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    return value as T[];
};
